// extracted by mini-css-extract-plugin
module.exports = {"title":"ScoreTypeSelector_title__2V5pI","container":"ScoreTypeSelector_container__36Tyu","selectDifficultyWrapper":"ScoreTypeSelector_selectDifficultyWrapper__ewJXb"};